// GlobalStateProvider.js
import React from "react";
import { useImmerReducer } from "use-immer";
import StateContext from "./StateContext";
import DispatchContext from "./DispatchContext";

const initialState = {
    jwtAccessToken: localStorage.getItem("jwtAccessToken"),
    jwtRefreshToken: localStorage.getItem("jwtRefreshToken"),
    userId: localStorage.getItem("userId"),
    userUsername: localStorage.getItem("userUsername"),
    userEmail: localStorage.getItem("userEmail"),
    userIsLogged: !!localStorage.getItem("jwtAccessToken"),
    isLoaded: false,
    userProfile: null,
    exchangeRates: {
        huf: 0,
        eur: 0,
        usd: 0,
        gbp: 0,
        chf: 0,
        error: false
    }
};

function reducer(draft, action) {
    switch (action.type) {
        case "catchToken":
            draft.jwtAccessToken = action.tokenValue;
            draft.jwtRefreshToken = action.refreshToken;
            draft.userIsLogged = true;
            localStorage.setItem("jwtAccessToken", action.tokenValue);
            localStorage.setItem("token", action.tokenValue); // Backwards compatibility
            localStorage.setItem("jwtRefreshToken", action.refreshToken);
            break;
        case "userSignsIn":
            draft.userId = action.IdInfo;
            draft.userUsername = action.usernameInfo;
            draft.userEmail = action.emailInfo;
            draft.userIsLogged = true;
            localStorage.setItem("userId", action.IdInfo);
            localStorage.setItem("userUsername", action.usernameInfo);
            localStorage.setItem("userEmail", action.emailInfo);
            break;
        case "logout":
            draft.jwtAccessToken = null;
            draft.jwtRefreshToken = null;
            draft.userId = null;
            draft.userUsername = null;
            draft.userEmail = null;
            draft.userIsLogged = false;
            draft.isLoaded = false;
            draft.userProfile = null;
            localStorage.removeItem("jwtAccessToken");
            localStorage.removeItem("jwtRefreshToken");
            localStorage.removeItem("token");
            localStorage.removeItem("userId");
            localStorage.removeItem("userUsername");
            localStorage.removeItem("userEmail");
            break;
        case "catchUserProfileInfo":
            draft.userProfile = action.profile;
            draft.isLoaded = true;
            break;
        case "setExchangeRates":
            draft.exchangeRates = action.rates;
            break;
        default:
            break;
    }
}

function GlobalStateProvider({ children }) {
    const [state, dispatch] = useImmerReducer(reducer, initialState);
    return (
        <StateContext.Provider value={state}>
            <DispatchContext.Provider value={dispatch}>
                {children}
            </DispatchContext.Provider>
        </StateContext.Provider>
    );
}
export default GlobalStateProvider;
